import { render, staticRenderFns } from "./HeaderSignature.vue?vue&type=template&id=7e0bbb70&"
import script from "./HeaderSignature.vue?vue&type=script&lang=ts&"
export * from "./HeaderSignature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0bbb70')) {
      api.createRecord('7e0bbb70', component.options)
    } else {
      api.reload('7e0bbb70', component.options)
    }
    module.hot.accept("./HeaderSignature.vue?vue&type=template&id=7e0bbb70&", function () {
      api.rerender('7e0bbb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/HeaderSignature.vue"
export default component.exports